import {Routes} from '@angular/router';
import {AppLayout} from '@/layout/components/app.layout';
import {LandingLayout} from '@/layout/components/app.landinglayout';
import {AuthLayout} from '@/layout/components/app.authlayout';
import {Notfound} from '@/pages/notfound/notfound';
import { IdpLoginComponent } from '@/idp-login/idp-login.component';
import { authGuard } from '@/guards/auth.guard';
import { clientRedirectGuard } from '@/guards/client-redirect.guard';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: IdpLoginComponent,

    },

    {
        path: 'home',
        component: AppLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/idp-customer/idp-customer.component').then((c) => c.IdpCustomerComponent),
                canActivate: [clientRedirectGuard],
                data: {breadcrumb: 'Clients'}
            },            
            
            {
                path: 'extraction',
                loadChildren: () => import('@/pages/pages.routes'),
                data: {breadcrumb: 'Extraction'}
            },
            {
                path: 'comparison',
                loadChildren: () => import('@/comparison/comparison.routes'),
                data: {breadcrumb: 'Comparison'}
            },
            {
                path: 'administration',
                loadChildren: () => import('@/administration/administration.routes'),
                data: {breadcrumb: 'Administration'}
            },           
            {
                path: 'masterdata',
                loadChildren: () => import('@/masterdata/masterdata.routes'),
                data: {breadcrumb: 'Masterdata'}
            },           
        ],
        canActivate: [authGuard]    
    },
    // New top-level Extraction route without 'home' prefix (keeps layout and guards)
    {
        path: 'extraction',
        component: AppLayout,
        children: [
            {
                path: '',
                loadChildren: () => import('@/pages/pages.routes'),
                data: {breadcrumb: 'Extraction'}
            }
        ],
        canActivate: [authGuard]
    },
    {
        path: 'landing',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/landing').then((c) => c.Landing)
            },
            
            {
                path: 'pricing',
                loadComponent: () => import('@/pages/landing/pricing').then((c) => c.Pricing)
            },
            {
                path: 'contact',
                loadComponent: () => import('@/pages/landing/contact').then((c) => c.Contact)
            },
            {
                path: 'oops',
                loadComponent: () => import('@/pages/oops/oops').then((c) => c.Oops)
            },
            {
                path: 'error',
                redirectTo: '/notfound'
            }
        ]
    },
    {path: 'notfound', component: Notfound},
    {
        path: 'forbidden',
        loadComponent: () => import('@/pages/forbidden/forbidden.component').then((c) => c.ForbiddenComponent)
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: []
    },
    {path: '**', redirectTo: '/notfound'}
];
